import { combineReducers } from 'redux';
import projectReducer from './features/project/reducer';
import toastsReducer from './features/toasts/reducer';
import telemetryReducer from './features/telemetry/reducer';
var rootReducer = combineReducers({
    project: projectReducer,
    toasts: toastsReducer,
    telemetry: telemetryReducer,
});
export default rootReducer;
